import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgThunder = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M25.1831 3.30805C25.3764 3.11476 25.6728 3.06955 25.9149 3.19636C26.157 3.32323 26.2885 3.59268 26.2396 3.86164L23.8733 16.8756H31.8738C32.1226 16.8756 32.3477 17.0233 32.4469 17.2515C32.5461 17.4798 32.5007 17.7453 32.3309 17.9272L14.8321 36.6766C14.6435 36.8787 14.3442 36.9327 14.0967 36.8096C13.8491 36.6864 13.7116 36.415 13.7591 36.1425L16.2488 21.8749H8.12498C7.87222 21.8749 7.64435 21.7227 7.54759 21.4892C7.45085 21.2557 7.50434 20.9868 7.68309 20.8081L25.1831 3.30805ZM9.63377 20.6249H16.9916C17.1761 20.6249 17.3513 20.7065 17.4701 20.8477C17.5888 20.989 17.6391 21.1756 17.6074 21.3574L15.3515 34.2864L30.4352 18.1256H23.125C22.9397 18.1256 22.764 18.0432 22.6452 17.9009C22.5265 17.7587 22.4772 17.5712 22.5104 17.3889L24.6521 5.60603L9.63377 20.6249Z",
		fill: "currentColor"
	})
});
export default SvgThunder;
